
export enum EventDefine {
    ConfigChange = "ConfigChange",

    CustomerInfoChange = "CustomerInfoChange",

    ChangeHallTopTab = "ChangeHallTopTab",
    HideWalletBtnsToast = "HideWalletBtnsToast",
    HideProvidersFilterToast = "HideProvidersFilterToast",
    HideGameFilterToast = "HideGameFilterToast",

    MoneyChange = "MoneyChange",
    UserInfoChange = "UserInfoChange",
    VipLevelChange = "VipLevelChange",

    OTPGeted = "OTPGeted",

    HallGameSearchShow = "HallGameSearchShow",
    HallGameSearchClear = "HallGameSearchClear",
    HallGameSearchChange = "HallGameSearchChange",
    HallGameSearchChangeGame = "HallGameSearchChangeGame",
    HallShowPwaInstaller = "HallShowPwaInstaller",    //显示PWA安装引导

    GameSearchShow = "GameSearchShow",
    GameSearchClear = "GameSearchClear",
    GameSearchChange = "GameSearchChange",
    GameSearchHallChange = "GameSearchHallChange",
    GameSearchChangeGame = "GameSearchChangeGame",
    GameTypeChange = "GameTypeChange",
    ProvidersFilterItemChecked = "ProvidersFilterItemChecked",
    ProvidersFilterChange = "ProvidersFilterChange",
    GameTypeFilterChange = "GameTypeFilterChange",

    RefreshSubgameList = "RefreshSubgameList",
    PlayedGameIdsChange = "PlayedGameIdsChange",

    SignInfoChange = "SignInfoChange", //签到信息回调
    SignReward = "SignReward", //签到信息领取回调
    SignRewardAgg = "SignRewardAgg", //累计签到返回

    GetVipInfo = "GetVipInfo",
    BuyedVip = "BuyedVip",

    PopupEndToNext = "PopupEndToNext",//下一个弹窗
    TryAddPopupView = "TryAddPopupView",//添加弹窗
    AllPopupViewClose = "AllPopupViewClose",

    VipDailyCashChange = "VipDailyCashChange",
    GetVipDailyReward = "GetVipDailyReward",

    PayMentChange = "PayMentChange",
    PayChannelSelectChecked = "PayChannelSelectChecked",
    PaymentSuccessful = "PaymentSuccessful",

    PayWheelChange = "PayWheelChange",
    PayWheelSpin = "PayWheelSpin",
    WheelReward = "WheelReward",

    VipEquityRecvReward = "VipEquityRecvReward",
    VipEquityList = "VipEquityList",
    VipEquityConfig = "VipEquityConfig",

    ShareRewaedChange = "ShareRewaedChange",
    ShareRulehange = "ShareRulehange",
    ShareReferralsChange = "ShareReferralsChange",
    ShareReferralsChangeMax = "ShareReferralsChangeMax",
    ShareRecvReward = "ShareRecvReward",

    Native2Lua = "Native2Lua",

    BankInfosChange = "BankInfosChange",
    WithDrawGoldChecked = "WithDrawGoldChecked",
    PlayerMoneyChange = "PlayerMoneyChange",
    BankAccChange = "BankAccChange",//绑定的银行卡信息
    BankAccChangeSuccess = "BankAccChangeSuccess",//绑定的新银行卡信息成功

    TransactionTypeChange = "TransactionTypeChange",
    TransactionBtnsToastClosed = "TransactionBtnsToastClosed",
    TransactionDataChange = "TransactionDataChange",

    UnreadMailCountChange = "UnreadMailCountChange",
    GetMailContent = "GetMailContent",
    MailListChange = "MailListChange",

    GoodsListChange = "GoodsListChange",
    ShopItemChecked = "ShopItemChecked",
    ShopPayChannelChecked = "ShopPayChannelChecked",

    RolloverTopChange = "RolloverTopChange",
    RolloverListChange = "RolloverListChange",
    RolloverListChangeMax = "RolloverListChangeMax",
    MoneyAnimPlay = "MoneyAnimPlay",
    MoneyAnimFinished = "MoneyAnimFinished",

    EggCapsuleIning = "EggCapsuleIning",//扭蛋机进入
    EggCapsuleGoldChange = "EggCapsuleGoldChange",//刷新扭蛋机金额
    EggCapsuleUserChange = "EggCapsuleUserChange",//刷新扭蛋机邀请玩家信息
    EggCapsuleAddGold = "EggCapsuleAddGold",//刷新扭蛋机领取金币

    SendOTPSuccess = "SendOTPSuccess",
    SendOTPFail = "SendOTPFail",

    BindPhoneSuccess = "BindPhoneSuccess",
    BindPhoneOk = "BindPhoneOk",
    BindPhoneFail = "BindPhoneFail",

    WelcomeList = "WelcomeList",//获取新人礼包数据
    WelcomeChecked = "WelcomeChecked",//获取新人礼包

    ChangeActivityRed = "ChangeActivityRed",//刷新界面侧边栏活动界面
    ChangeBindActivityRed = "ChangeBindActivityRed",//刷新列表排序

    TurnTableChangTipsChange = "TurnTableChangTipsChange", //转盘提示数据刷新
    TurnTableChange = "TurnTableChange", //转盘数据刷新
    TurnTableReward = "TurnTableReward", //转盘奖励回调
    TurnTableOpen = "TurnTableOpen", //处理报错

    ChangeHallRankFraction = "ChangeHallRankFraction", //今日排行榜分数刷新
    ChangeRankList = "ChangeRankList", //刷新排行榜界面
    RankRewardGet = "RankRewardGet",//排行榜奖励获取
    RankRewardEnd = "RankRewardEnd",//排行榜奖励领取

    LoginAgain = "LoginAgain",//加载界面登录不成功重新登录

    Lucky2DBetResult = "Lucky2DBetResult",//2d下注结果
    Lucky2DBetProgress = "Lucky2DBetProgress",//2d下注进度

    Lucky3DBetResult = "Lucky3DBetResult",//3d下注结果
    Lucky3DBetProgress = "Lucky3DBetProgress",//3d下注进度

    PddChangTipsChange = "PddChangTipsChange", //拼多多跑马灯数据刷新
    PddChangPlayerData = "PddChangPlayerData", //拼多多活动数据刷新
    PddSpinWinChange = "PddSpinWinChange", //拼多多转盘中奖回调
    PddPrizeChange = "PddPrizeChange", //拼多多领取奖金
    PddWinRecordChange = "PddWinRecordChange", //拼多多winRecord数据
    PddGiftGetChange = "PddGiftGetChange", //拼多多领取完礼盒

    ChangeProviderList = "ChangeProviderList",//刷新大厅底部厂商游戏数量

    OnLoginChange = "OnLoginChange",  //登录账号返回
    OnLoginChangeErr = "OnLoginChangeErr",  //登录账号错误 - 玩家输入账号不存在
    OnLoginPassErr = "OnLoginPassErr",  //登录账号错误 - 密码错误

    OnRegisterChange = "OnRegisterChange",  //注册返回
    OnRegisterUserErr = "OnRegisterUserErr",  //注册错误 - 玩家输入账号已经存在
    OnRegisterPhoneErr = "OnRegisterPhoneErr",  //注册错误 - 手机号码不存在

    OnForgotChange = "OnForgotChange",  //忘记密码账号正确返回
    OnForgotPassChange = "OnForgotPassChange",  //忘记密码新密码返回
    OnForgotUserErr = "OnForgotUserErr",  //忘记密码 - 玩家输入账号不存在
    OnForgotPhoneErr = "OnForgotPhoneErr",  //忘记密码-- - 手机号码不存在
    OnForgotUserAndPhoneErr = "OnForgotUserAndPhoneErr",  //忘记密码-- - 账号与手机号码不匹配

    OnProfileChange = "OnProfileChange",  //验证自己的手机号码正确返回
    OnNewProfileChange = "OnNewProfileChange",  //重置手机号码正确返回
    OnProfilePhoneErr = "OnProfilePhoneErr",  //重置手机号码-- - 手机号与原始手机号不一致
    OnNewProfilePhoneErr = "OnNewProfilePhoneErr",  //重置手机号码-- - 输入的手机号已被使用

    OnRecgatgePhoneChange = "OnRecgatgePhoneChange",  //支付修改手机号 -- 手机号修改成功回调
    OnRecgatgePhoneErr = "OnRecgatgePhoneErr",  //支付修改手机号-- - 手机号与原始手机号不一致

    OnBindPhoneChange = "OnBindPhoneChange", // 绑定手机号 -- 成功返回
    OnBindPhoneUserError = "OnBindPhoneUserError",  //绑定手机号-- - 玩家输入账号已存在
    OnBindPhoneError = "OnBindPhoneError",  //绑定手机号-- - 输入的手机号已被使用

    HallShowBIndPhone = "HallShowBIndPhone",  //绑定手机号弹窗

    OnWaterWheelChange = "OnWaterWheelChange", //流水大转盘数据返回
    OnWaterWheelSpinChange = "OnWaterWheelSpinChange", //流水大转盘抽奖数据返回

    OnBonanzaInfoChange = "OnBonanzaInfoChange", //累计充值数据返回
    OnBonanzaInfoReward = "OnBonanzaInfoReward", //累计充值领取奖励数据返回

    OnGetFreeSpinInfo = "OnGetFreeSpinInfo", //免费转信息返回

    OnDailyTaskInfo = "OnDailyTaskInfo", //前端请求每日任务数据返回
    OnDailyTaskGoldChange = "OnDailyTaskGoldChange", //前端请求领取每日任务奖励返回
    OnDailyTaskGoldBtn = "OnDailyTaskGoldBtn", //前端请求领取每日任务奖励返回修改按钮

    OnMysticaBoxInfo = "OnMysticaBoxInfo", //前端请求寻宝返回
    OnMysticaBoxChange = "OnMysticaBoxChange", //前端请求领取寻宝奖励返回
    OnMarqueeInfo  = "OnMarqueeInfo",//跑马灯下发

    OnInviteChestInfo = "OnInviteChestInfo", //分享人数数据刷新
    OnInviteChestGet = "OnInviteChestGet", //领取分享人数数据
    OnReferralBoxInfo = "OnReferralBoxInfo", //分享宝箱数据刷新
    OnReferralBoxGet = "OnReferralBoxGet", //分享宝箱数据领取
    onschelirJackList = "onschelirJackList",//开始刷新排行榜游戏列表
    onJackListShow = "onJackListShow",//回到大厅刷新排行榜游戏列表


    OnJackPotGemsInfo = "OnJackPotGemsInfo",//刷新jackpot宝石分享
    OnJackPotGemsGet = "OnJackPotGemsGet",//返回jackpot宝石点击
    OnJackPotGemsGold = "OnJackPotGemsGold",//返回jackpot宝石奖励
    LanguageChange = "LanguageChange",
}